export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.20-2158.54",
  commitId: "bdfe305e28f9928299a05beca5460103bb238d20",
  commitTime: "2026-07-20T21:58:54.000Z",
});
